export const ProductType = {
  installments: 'installments',
  default: 'default',
} as const;

export type ProductType = (typeof ProductType)[keyof typeof ProductType];
